<template class="service-call">
  <v-dialog
    :value="true"
    persistent
    max-width="600px"
    class="z"
  >
    <v-card :loading="isLoading">
      <v-card-title class="pa-3">
        <span class="headline">Nova Solicitação</span>
      </v-card-title>
      <v-card-text>
        <span class="subline pa-3">
          Crie um novo Registro de solicitação do cliente
        </span>
        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="service"
                  :items="servicesList"
                  :rules="[$rules.required()]"
                  :item-text="item => `${item.endereco} - ${item.centralParticao} - ${item.tipoConta}`"
                  :item-value="item => item"
                  label="Serviço"
                  placeholder="Selecione o Serviço"
                  @change="agenda"
                  single-line
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-if="service && getAgenda"
                  v-model="schedule"
                  :items="getAgenda"
                  :rules="[$rules.required()]"
                  :item-text="item => item.label"
                  :item-value="item => item.value"
                  label="Agenda"
                  placeholder="Selecione um Horário"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="message"
                  label="Mensagem"
                  placeholder="Digite a mensagem"
                  :rules="[$rules.required()]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          rounded
          large
          :disabled="!valid"
          v-on:click="switchLoading()"
          @click="onAddClick({contact: {email: currentUser.email, name: currentUser.name, phone: currentUser.phone, service, schedule, message, contactType: 2}, onSuccess})"
        >
          Adicionar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters, mapActions, mapState, createNamespacedHelpers} from 'vuex';
import { mask } from 'vue-the-mask';

const contactList = createNamespacedHelpers('views/contactList');

export default {
  name: 'ContactsAdd',
  directives: { mask },
  data: () => ({
    valid: false,
    name: null,
    email: null,
    phone: null,
    contactType: null,
    service: {},
    schedule: '',
    message: null,
  }),
  computed: {
    ...mapGetters('views/contactsList', [
      'contactTypes',
      'servicesList',
      'getAgenda',
      'isLoading'
    ]),
    ...mapState('session', [
      'currentAccount',
      'currentUser',
    ]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadServices();
    });
  },
  methods: {
    ...mapActions('views/contactsList', [
      'onAddClick',
      'loadServices',
      'loadSchedules',
      'serviceCall',
      'switchLoading',
    ]),
    onSuccess(data) {
      this.serviceCall(data);
    },
    agenda(service) {
      this.loadSchedules(service.technicianId);
    },
  },
};
</script>

<style>
#blip-chat-open-iframe{
  visibility: hidden;
}

.v-list-item__content{
  overflow: visible!important;
}

.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle{
  font-size: 0.7rem;
}
</style>
